export default import.meta.ROLLDOWN_FILE_URL_g7GF79fdYiVx4JT7dzonJA